import { Chip, Tooltip } from '@mui/material';
import { EyeOff } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';
import useSensitiveInfoReveal from '~/hooks/patient/useSensitiveInfoReveal';

/**
 * Affordance shown in place of the patient breadcrumb's name when sensitive
 * info is hidden, so the hidden state is visible exactly where the user
 * looks for patient identity. Click un-hides without opening the menu.
 *
 * Renders nothing when sensitive info is visible.
 */
const PatientInfoHiddenChip = () => {
    const { isInfoShown, requestReveal } = useSensitiveInfoReveal();
    const intl = useIntl();

    if (isInfoShown) {
        return null;
    }

    const ariaLabel = intl.formatMessage({ id: 'patientInfoHiddenChip' });

    return (
        <Tooltip title={<FormattedMessage id="patientInfoHiddenChipTooltip" />}>
            <Chip
                variant="outlined"
                size="small"
                color="primary"
                icon={<EyeOff size={14} />}
                label={<FormattedMessage id="patientInfoHiddenChip" />}
                onClick={(e) => {
                    // Stop the click bubbling to the parent BreadcrumbButton,
                    // which would otherwise open the patient menu instead of
                    // requesting the reveal.
                    e.stopPropagation();
                    requestReveal();
                }}
                aria-label={ariaLabel}
                sx={{
                    px: 0.5,
                    minHeight: 0,
                    height: 20,
                    fontSize: 11,
                }}
                data-testid="patient-info-hidden-chip"
            />
        </Tooltip>
    );
};

export default PatientInfoHiddenChip;
